import { render, staticRenderFns } from "./BoxlogNew.vue?vue&type=template&id=df7ce4f0&scoped=true"
import script from "./BoxlogNew.vue?vue&type=script&lang=js"
export * from "./BoxlogNew.vue?vue&type=script&lang=js"
import style0 from "./BoxlogNew.vue?vue&type=style&index=0&id=df7ce4f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7ce4f0",
  null
  
)

export default component.exports